module.exports = __webpack_public_path__ + "static/media/logo_b.a15e3146.png";